<template>
  <ProSpaceRightPanel
    :header="header"
    :loading="loading"
    :has-error="hasError"
    @edit="editPanel"
    @adjustmentRequest="adjustmentRequest"
    @delete="deletePanel"
    @show-history="showHistoryPanel"
    @showAgencyTerritory="showAgencyTerritoryModal"
  >
    <template v-if="isMultipleView()" v-slot:center>
      <ProSpaceVLayout :gap="10">
        <PanelBlockSelectedItems :items="[
            { name: $t('addressProgramOrderOutletId'), value: 'outletId', f: (v) => v },
            { name: $t('network'), value: 'networkValue', f: (v) => v },
          ]"
        />
        <ProSpacePanelBlock v-if="isAllRowsSelected" class="prospace-panel-block--empty" :header="{title: $t('itemsSelectedAll')}">
          <template #header>
            <ProSpaceAction
              :text="$t('clearTxt')"
              @click="clearPanelAll"
            />
          </template>
        </ProSpacePanelBlock>
        <ProSpacePanelBlock :header="hideAdjustmentRequest ? '' : headerAction">
          <ProSpaceVLayout :gap="10">
            <ProSpaceAction
              v-if="!hideAdjustmentRequest"
              :text="$t('adjustmentRequest')"
              @click="adjustmentRequest"
            />
            <ProSpaceAction
              v-if="isUserHasAgencyRole && currentPeriod.status != 'closed'"
              :text="$t('setAgencyTerritoryParams')"
              @click="showAgencyTerritoryModal"
            />
          </ProSpaceVLayout>
        </ProSpacePanelBlock>
      </ProSpaceVLayout>
    </template>
    <template v-else-if="selectedCount === 1" v-slot:center>
      <ProSpaceTabs v-model="modelTab" :tabs="tabs" @select-tab="onSelectTab">
        <template v-slot:tab-1>
          <ProSpacePanelBlock v-if="content?.length > 0" :header="headerAddressProgramOrders">
            <template v-slot:header>
              <ProSpaceAction
                v-if="!hideAdjustmentRequest"
                :text="$t('adjustmentRequest')"
                @click="adjustmentRequest"
              />
              <ProSpaceAction
                v-if="isGroupingGrid && !isGroupingOutletsMode"
                :text="$t('open')"
                @click="$emit('openOutletsList')"
              />
            </template>
            <template v-slot>
              <ProSpacePanelBlockList :itemsPerPage="100" :list="content" />
            </template>
          </ProSpacePanelBlock>
        </template>
        <template v-slot:tab-2>
          <ProSpaceVLayout :gap="10" style="padding-bottom: 10px;">
            <ProSpacePanelBlock v-if="!isGroupingGrid || isGroupingOutletsMode" :header="openParameters">
              <template v-slot:content>
                <ProSpaceHLayout
                  class="address-program__kpi-block"
                  justify-content="space-between"
                >
                  <span class="address-program__kpi-title">{{ $t("ratePerHour") }}</span>
                  <span class="address-program__kpi-value">{{
                      formatDigit(selectedData.ratePerHourPlan)
                    }}</span>
                </ProSpaceHLayout>
                <ProSpaceHLayout
                  class="address-program__kpi-block"
                  justify-content="space-between"
                >
                  <span class="address-program__kpi-title">{{ $t("timingPerVisit") }}</span>
                  <span class="address-program__kpi-value">{{
                      formatDigit(selectedData.timingPerVisitPlan)
                    }}</span>
                </ProSpaceHLayout>
              </template>
            </ProSpacePanelBlock>
            <ProSpacePanelBlock :header="openKpi"/>
            <TableKpiCoverage
              :addressProgramOrder="addressProgramOrder"
            />
            <ProSpacePanelBlock :header="businessKpi"/>
            <TableKpiBusiness
              :addressProgramOrder="addressProgramOrder"
            />
          </ProSpaceVLayout>
        </template>
        <template v-slot:tab-3>
          <ProSpaceVLayout :gap="10" style="padding-bottom: 10px;">
            <ProSpacePanelBlock :header="adjustmentsHeader" class="address-program__order-panel_adjustments">
              <template v-slot>
                <ProSpaceMainGrid
                  ref="adjustmentGrid"
                  getMethod="gridAndParseEditedFieldsConfig"
                  defaultSortField="id"
                  isHeadHide
                  removeBgOnly
                  isInForm
                  :defaultSortOrder="-1"
                  :service="adjustmentService"
                  :defaultFilter="adjustmentFilter"
                >
                  <template #columns>
                    <Column style="max-width: 35%">
                      <template #body="field">
                        <ProSpaceVLayout :gap="5" justify-content="center">
                          <div
                            class="text-color-main text-bold text-ellipsis w-100"
                            style="line-height: 14px"
                          >
                            {{ field.data.name }}
                          </div>
                          <ProSpaceTag
                            v-bind="
                        getAdjustmentStatus(field.data) || {
                          type: 'draft',
                          text: field.data.status,
                        }
                      "
                          />
                        </ProSpaceVLayout>
                      </template>
                    </Column>
              <Column v-if="isGroupingGrid && !isGroupingOutletsMode" style="max-width: 23%">
                <template #body="field">
                  <ProSpaceTextBlock
                    type="five"
                    :top="$t('adjustmentOutletCode')"
                    :bottom="field.data.outletCode"
                    :gap="3"
                    justify-content="center"
                  />
                </template>
              </Column>
                    <Column style="max-width: 21%">
                      <template #body="field">
                        <ProSpaceTextBlock
                          type="five"
                          :top="$t('adjustmentOldValue')"
                          :bottom="getFieldOldValue(field.data)"
                          :title="getFieldOldValue(field.data)"
                          :gap="3"
                          justify-content="center"
                        />
                      </template>
                    </Column>
                    <Column style="max-width: 21%">
                      <template #body="field">
                        <ProSpaceTextBlock
                          type="five"
                          :top="$t('adjustmentNewValue')"
                          :bottom="getFieldNewValue(field.data)"
                          :title="getFieldNewValue(field.data)"
                          :gap="3"
                          justify-content="center"
                        />
                      </template>
                    </Column>
                    <Column style="max-width: 21%">
                      <template #body="field">
                        <ProSpaceDateTimeColumn
                          :date="field.data.date"
                          :dateFormat="userinfo.dateFormat"
                          :timeFormat="userinfo.timeFormat"
                        />
                      </template>
                    </Column>
                  </template>
                  <template #empty>
                    <ProSpaceEmptyGrid
                      :title="$t('adjustmentEmptyCommentsTitleTxt')"
                      :text="$t('adjustmentEmptyCommentsTextTxt')"
                      icon="empty-grid"
                    />
                  </template>
                </ProSpaceMainGrid>
              </template>
            </ProSpacePanelBlock>
          </ProSpaceVLayout>
        </template>
        <template v-slot:tab-4>
          <ProSpacePanelBlock :header="budgetHeader">
            <template v-slot:header>
              <ProSpaceTag
                v-if="factBudgetApproved"
                :type="'teal'"
                :text="$t(`factBudgetApprovedRightPanel`)"
                is-border-style
              />
            </template>
          </ProSpacePanelBlock>
          <TableKpiBudget
            :addressProgramOrder="addressProgramOrder"
          />
        </template>
      </ProSpaceTabs>
    </template>
    <template #bottom>
    </template>
  </ProSpaceRightPanel>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceAction,
  ProSpaceHLayout,
  ProSpaceVLayout,
  ProSpaceSimpleGrid,
  ProSpaceModal,
  ProSpaceGeoLayout,
  ProSpaceMainGrid,
  ProSpaceTextBlock,
  ProSpaceTag,
  ProSpaceEmptyGrid,
  ProSpaceDateTimeColumn
} from "@prospace/prospace-components-library";
import { AddressProgramOrderService } from "../../../services/AddressProgramOrderService";
import { AdjustmentService } from "../../../services/AdjustmentService"
import { mapGetters } from "vuex";
import AddressProgramKpiStats from "./AddressProgramKpiStats.vue";
import Column from "primevue/column";
import formatDigit from "@prospace/prospace-components-library/src/lib-assets/mixins/digitFormatter";

import {
  useMultiSelectRightPanel,
} from "@composes/multiselect"
import PanelBlockSelectedItems from "@multiselect/PanelBlockSelectedItems"
import moment from 'moment';
import TableKpiBusiness from "@components/entities/TableKpiBusiness";
import TableKpiBudget from "@components/entities/TableKpiBudget";
import TableKpiCoverage from "@components/entities/TableKpiCoverage";
export default {
  name: "AddressProgramOrderPanel",
  // mixins: [accessMixin],
  components: {
    ProSpaceSimpleGrid,
    AddressProgramKpiStats,
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceAction,
    ProSpaceHLayout,
    ProSpaceVLayout,
    Column,
    ProSpaceModal,
    ProSpaceGeoLayout,
    PanelBlockSelectedItems,
    ProSpaceMainGrid,
    ProSpaceTextBlock,
    ProSpaceTag,
    TableKpiBusiness,
    TableKpiBudget,
    TableKpiCoverage,
    ProSpaceEmptyGrid,
    ProSpaceDateTimeColumn
  },
  emits: ['select-tab'],
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isGroupingGrid: {
      type: Boolean,
      required: true,
    },
    selectedGroups: {
      type: Array,
    },
    hideRequest: {
      type: Boolean,
      required: true,
    },
    checkAccess: {
      type: Function,
    },
    wrapperCheckRoles: {
      type: Function
    },
    dotsWrapper: {
      type: Function,
    },
    isGroupingOutletsMode: {
      type: Boolean,
      default: false
    },
    isUserHasAgencyRole: {
      type: Boolean,
      default: false
    },
    isUserHasAgency: {
      type: Boolean,
      default: false
    },
    isAllRowsSelected: {
      type: Boolean,
      default: false
    },
    currentPeriod:{
      type: Object,
      required: true
    }
  },
  setup() {
    const { selectedData, selectedClude, selectedCount, isMultipleView } = useMultiSelectRightPanel()
    return {
      selectedData, selectedClude, selectedCount, isMultipleView
    }
  },
  data() {
    return {
      addressProgramOrder: null,
      loading: false,
      hasError: false,
      addressProgramOrderService: new AddressProgramOrderService(),
      adjustmentService: new AdjustmentService(),
      modelModalClude: false,
      modelTab: {
        name: this.$t("parameters"), isActive: true, systemName: "parameters"
      },
      percentageKeys: ["osaPlan", 'deltaISAOSAPlan'],
      formattingKeys: [
        "ratePerHourPlan",
        "ratePerHourFact",
        "timingPerVisitPlan",
        "timingPerVisitFact",
        "fteMerchPlan",
        "fteMerchFact",
        "osaPlan",
        "osaFact",
        "deltaISAOSAPlan",
        "deltaISAOSAFact",
        "visitSumPlan",
        "osaSumPlan",
        "totalSumPlan",
        "visitSumFact",
        "osaSumFact",
        "totalSumFact",
        "osaTargetPlanW",
        "osaTargetFactW",
        "osaReportPlanW",
        "osaReportFactW",
        "pogWetWHSPlan",
        "pogWetPFTPlan",
        "pogWetSHBPlan",
        "pogDryWHSPlan",
        "pogDryPFTPlan",
        "lSizePlan",
        "stripeCTDreamPlan",
        "stripePFTCatPlan",
        "stripePFDogPlan",
        "stripeSPPlan",
        "ctShareDreamPlan",
        "ctSharePFCatPlan",
        "ctSharePFDogPlan",
        "exSitePlan",
        "hotZonePlan"
      ],
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
    }),
    hideAdjustmentRequest() {
      return this.hideRequest
      || (Array.isArray(this.addressProgramOrder) &&
          this.addressProgramOrder
            .some(x => x.orderStatus !== "published" &&
              !(x.orderStatus === 'approved' && x.status === 'planfact')))
      || (this.addressProgramOrder &&
          this.addressProgramOrder.orderStatus !== "published" &&
          !(this.addressProgramOrder.orderStatus === 'approved' &&
            this.addressProgramOrder.status === 'planfact'));
    },
    headerAddressProgramOrders() {
      return {
        title: this.$t("parameters"),
        isExpand: false,
      };
    },
    openParameters() {
      return {
        title: this.$t("parameters"),
      };
    },
    openKpi() {
      return {
        title: this.$t("openKpi"),
      };
    },
    businessKpi() {
      return {
        title: this.$t("businessKpi"),
      };
    },
    adjustmentsHeader() {
      return {
        title: this.$t("adjustments"),
      };
    },
    budgetHeader() {
      return {
        title: this.$t("budget"),
      };
    },
    headerBottom() {
      return {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      };
    },
    tabs() {
      return [
        { name: this.$t("parameters"), isActive: true, systemName: "parameters" },
        { name: this.$t("businesskpi"), systemName: "businesskpi" },
        { name: this.$t("adjustments"), systemName: "adjustments" },
        { name: this.$t("budget"), systemName: "budget" },
      ];
    },
    header() {
      if (this.isGroupingGrid && !this.isGroupingOutletsMode) {
        return {
          title: this.$t("outletCount"),
          counter: this.selectedData?.outletCount,
          showCounter: this.selectedData?.outletCount,
        };
      }
      if (this.addressProgramOrder && this.selectedCount === 1) {
        return {
          title: this.addressProgramOrder.networkValue,
          id: this.addressProgramOrder.outletId,
          status: this.getStatus(this.addressProgramOrder.status),
          options: this.dotsWrapper ? this.dotsWrapper(this.addressProgramOrder) : this.options,
        };
      } else {
        return {
          title: this.$t("itemsSelectAll"),
          showCounter: true,
          counter: this.getCounter,
        };
      }
    },
    headerAction() {
      return {
        title: this.$t("actions"),
      };
    },
    content() {
      let content = [];
      if (this.addressProgramOrder) {
        const {
          city, area, clusterValue, hsrValue, tdmValue, kadlValue,
          outletTypeValue, externalFormatValue, channelValue, narkaValue, sipChannelValue, externalCode,
          territoryCluster, tariffZone, skyline, agencyValue, coverage, networkValue, kasValue, routeCodeValue,
          merchandiserValue, marsPeriodName
        } = this.addressProgramOrder
        if (this.isGroupingGrid && !this.isGroupingOutletsMode) {
          content.push(
            [{ title: this.$t("hsr"), text: hsrValue }],
            [{ title: this.$t("tdm"), text: tdmValue }],
            [{ title: this.$t("kadl"), text: kadlValue }]
          );

          if (this.checkAccess && this.checkAccess("agencyValue-rightPanel"))
            content.push([{ title: this.$t("agency"), text: agencyValue }]);

          content.push(
            [{ title: this.$t("network"), text: networkValue }],
            [{ title: this.$t("externalFormat"), text: externalFormatValue }],
            [{ title: this.$t("outletType"), text: outletTypeValue }],
            [{ title: this.$t("channel"), text: channelValue }],
            [{ title: this.$t("cluster"), text: clusterValue }],
            [{ title: this.$t("narka"), text: narkaValue }],
            [{ title: this.$t("sipChannel"), text: sipChannelValue }],
            [{ title: this.$t("kAS"), text: kasValue }]
          );
          content = content.filter((item) => item[0].text);
        } else {
          content.push(
            [{ title: this.$t("orderMarsPeriodName"), text: marsPeriodName }],
            [{ title: this.$t("city"), text: city }],
            [{ title: this.$t("area"), text: area }],
            [{ title: this.$t("cluster"), text: clusterValue }],
            [{ title: this.$t("hsr"), text: hsrValue }],
            [{ title: this.$t("tdm"), text: tdmValue }],
            [{ title: this.$t("kadl"), text: kadlValue }],
            [{ title: this.$t("outletType"), text: outletTypeValue }],
            [{ title: this.$t("externalFormat"), text: externalFormatValue }],
            [{ title: this.$t("channel"), text: channelValue }],
            [{ title: this.$t("narka"), text: narkaValue }],
            [{ title: this.$t("sipChannel"), text: sipChannelValue }],
            [{ title: this.$t("externalCode"), text: externalCode }],
            [{ title: this.$t("territoryCluster"), text: territoryCluster }],
            [{ title: this.$t("tariffZone"), text: tariffZone }],
            [{ title: this.$t("skyline"), text: skyline }]
          );

          if (this.checkAccess && this.checkAccess("agencyValue-rightPanel"))
            content.push([{ title: this.$t("agency"), text: agencyValue }]);

          content.push([
            {
              title: this.$t("coverage"),
              text: coverage ? this.$t("yes") : this.$t("no"),
            },
          ]);

          if (this.isUserHasAgency) {
            content.push([{ title: this.$t("kAS"), text: kasValue }]);
            content.push([{ title: this.$t("routeCode"), text: routeCodeValue }]);
            content.push([{ title: this.$t("merchandiser"), text: merchandiserValue }]);
          }
        }
      }
      return content;
    },
    contentBottom() {
      if (this.addressProgramOrder) {
        return [
          [
            {
              title: this.$t("createdByTxt"),
              text: this.addressProgramOrder.createdBy,
            },
            {
              title: this.$t("updatedByTxt"),
              text: this.addressProgramOrder.updatedBy,
            },
            {
              title: this.$t("createdAtTxt"),
              text: new Date(this.addressProgramOrder.createdAt),
              dateFormat: this.userinfo.dateFormat,
            },
            {
              title: this.$t("lastUpdatedTxt"),
              text: new Date(this.addressProgramOrder.lastUpdated),
              dateFormat: this.userinfo.dateFormat,
            },
          ],
        ];
      }
      return [];
    },
    budgetKpi() {
      return [
        {
          title: this.$t('totalSum'),
          plan: this.addressProgramOrder.totalSumPlan,
          fact: this.addressProgramOrder.totalSumFact,
          formatNumber: true,
          separatorType: ".",
          bold: true
        },
        {
          title: this.$t('visitSum'),
          plan: this.addressProgramOrder.visitSumPlan,
          fact: this.addressProgramOrder.visitSumFact,
          formatNumber: true,
          separatorType: "."
        },
        {
          title: this.$t('oSASum'),
          plan: this.addressProgramOrder.osaSumPlan,
          fact: this.addressProgramOrder.osaSumFact,
          formatNumber: true,
          separatorType: "."
        },
        {
          title: this.$t('isaOsaSum'),
          plan: this.addressProgramOrder.deltaISAOSASumPlan,
          fact: this.addressProgramOrder.deltaISAOSASumFact,
          formatNumber: true,
          separatorType: "."
        },
        {
          title: this.$t('pSSSum'),
          plan: this.addressProgramOrder.pssSumPlan,
          fact: this.addressProgramOrder.pssSumFact,
          formatNumber: true,
          separatorType: "."
        },
        {
          title: this.$t('tacticalTaskSum'),
          plan: this.addressProgramOrder.tacticalTaskSumPlan,
          fact: this.addressProgramOrder.tacticalTaskSumFact,
          formatNumber: true,
          separatorType: "."
        }
      ]
    },
    getCounter() {
      return this.selectedCount || 0;
    },
    kpiTableHeader() {
      return [
        {
          name: this.$t('kpi'),
          value: 'kpiName',
          f: (item) => item,
        },
        {
          name: this.$t('plan'),
          value: 'plan',
          f: (item) => item,
        },
        {
          name: this.$t('fact'),
          value: 'fact',
          f: (item) => item,
        },
        {
          name: '%',
          value: 'percent',
          f: (item) => item,
        },
      ]
    },
    adjustmentStatuses() {
      return new Map([
        [
          "accepted",
          { type: "teal", text: this.$t("accepted") },
        ],
        [
          "rejected",
          { type: "error", text: this.$t("adjustmentFieldDeclined") },
        ],
      ]);
    },
    adjustmentFilter() {
      let filter = {};
      if (this.isGroupingGrid && !this.isGroupingOutletsMode) {
        this.selectedGroups.forEach(g => {
          let val = this.addressProgramOrder[Object.keys(this.addressProgramOrder).find(key => key.toLowerCase() === g.toLowerCase())];
          filter[g] = { and: [val] };
        })
        filter.marsPeriodId = { and: [this.currentPeriod.id] };
        filter.disabled = { and: [false] };
        this.adjustmentService.isGroupingGrid = true;
      } else {
        filter.addressProgramOrderId = { and: [+this.addressProgramOrder.id] };
        filter.disabled = { and: [false] };
        this.adjustmentService.isGroupingGrid = false;
      }
      return filter;
    },
    factBudgetApproved() {
      return this.addressProgramOrder.orderStatus === 'factBudgetApproved';
    }
  },
  watch: {
    selectedData: {
      handler: function(val) {
        this.update();
        if (val?.outletId) {
          this.$nextTick(() => {
            if (this.modelTab.systemName === 'businesskpi') {
              this.$refs['kpiTable']?.getData()
              this.$refs['businessKpiTable']?.getData()
            }
            else if (this.modelTab.systemName === 'adjustments') {
              if (this.$refs['adjustmentGrid']) {
                this.$refs['adjustmentGrid'].filter = this.$refs['adjustmentGrid']?.defaultFilter
                this.$refs['adjustmentGrid'].records = []
              }
              this.$refs['adjustmentGrid']?.getRecords()
            }
            else if (this.modelTab.systemName === 'budget') {
              this.$refs['kpiBudgetTable']?.getData()
            }
          })
        } else if (this.isGroupingGrid && !this.isGroupingOutletsMode) {
          if (this.modelTab.systemName === 'adjustments') {
            this.$nextTick(() => {
              if (this.$refs['adjustmentGrid']) {
                this.$refs['adjustmentGrid'].filter = this.$refs['adjustmentGrid']?.defaultFilter
                this.$refs['adjustmentGrid'].records = []
              }
              this.$refs['adjustmentGrid']?.getRecords()
            })
          }
        }
      },
      immediate: true
    },
    selectedCount() {
      this.update()
    },
  },
  methods: {
    formatDigit,
    update() {
      this.hasError = false;
      try {
        this.getAddressProgramOrder();
      } catch (e) {
        this.hasError = true;
      }
    },
    getAddressProgramOrder() {
      this.addressProgramOrder = this.selectedData;
    },
    getStatus(status) {
      if (!status) return;
      let type = "default";
      let text = "";
      switch (status) {
        case "plan":
          type = "info";
          text = this.$t("planStatus");
          break;
        case "draft":
          type = "draft";
          text = this.$t("draftStatus");
          break;
        case "planfact":
          type = "teal";
          text = this.$t("planFactStatus");
          break;
      }
      return {
        text,
        type,
      };
    },
    clearPanel() {
      if (!this.isAllRowsSelected && (this.count === this.clude.items?.length)) {
        this.$emit("clear");
      } else if (this.isAllRowsSelected && (this.count > this.clude.items?.length) && this.clude.isAll) {
        this.$emit("clear:excluded");
      } else {
        this.$emit("clear");
      }
    },
    clearPanelAll() {
      this.$emit("clear");
    },
    editPanel() {
      this.$emit("edit", this.addressProgramOrder);
    },
    deletePanel() {
      this.$emit("delete", this.addressProgramOrder);
    },
    showHistoryPanel() {
      this.$emit("history", this.addressProgramOrder);
    },
    adjustmentRequest() {
      this.$emit("adjustment", this.addressProgramOrder);
    },
    showAgencyTerritoryModal() {
      this.$emit("showAgencyTerritoryModal", this.addressProgramOrder);
    },
    formatMomentDate(dateString) {
      return moment(dateString).format('DD.MM.YYYY hh:mm:ss');
    },
    getAdjustmentStatus(model) {
      const { adjustmentStatus, acceptanceStatus, approvalStatus } = model
      if (adjustmentStatus === 'onacceptance') {
        return { type: 'default', text: this.$t('adjustmentFieldRequested') }
      }
      if (adjustmentStatus === 'onapproval') {
        return acceptanceStatus === 'true' || acceptanceStatus === true
          ? { type: 'teal', text: this.$t('adjustmentFieldAccepted') }
          : { type: 'error', text: this.$t('adjustmentFieldDeclined') }
      }
      if (adjustmentStatus === 'completed') {
        return approvalStatus === 'true' || approvalStatus === true
          ? { type: 'teal', text: this.$t('adjustmentFieldAccepted') }
          : { type: 'error', text: this.$t('adjustmentFieldDeclined') }
      }
      if (adjustmentStatus === 'deleted') {
        if (acceptanceStatus === null) {
          return { type: 'default', text: this.$t('adjustmentFieldRequested') }
        }
        return acceptanceStatus === 'true' || acceptanceStatus === true
          ? { type: 'teal', text: this.$t('adjustmentFieldAccepted') }
          : { type: 'error', text: this.$t('adjustmentFieldDeclined') }
      }
    },
    onSelectTab(tab) {
      this.$emit('select-tab', tab);
    },
    getFieldOldValue(data) {
      if (!data) return null;
      let value = data.oldDisplayValue || data.oldValue;
      if (data.key == 'coverage') {
        value = this.$t(`coverage_${data.oldValue.toString().toLowerCase()}`);
      }
      if (!isNaN(value) && String(value).includes('.')) {
        value = parseFloat(value).toFixed(2);
      } else if (!isNaN(value.replace(',', '.')) && String(value.replace(',', '.')).includes('.')) {
        value = parseFloat(value.replace(',', '.')).toFixed(2);
      }
      if (this.formattingKeys.includes(data.key)) {
        value = formatDigit(value);
      }
      if (!isNaN(value) && this.percentageKeys.includes(data.key)) {
        value += '%';
      }
      return value;
    },
    getFieldNewValue(data) {
      if (!data) return null;
      let value = data.displayValue || data.newValue;
      if (data.key == 'coverage') {
        value = this.$t(`coverage_${data.newValue}`);
      }
      if (!isNaN(value) && String(value).includes('.')) {
        value = parseFloat(value).toFixed(2);
      }
      if (this.formattingKeys.includes(data.key)) {
        value = formatDigit(value);
      }
      if (!isNaN(value) && this.percentageKeys.includes(data.key)) {
        value += '%';
      }
      return value;
    },
  },
};
</script>

<style lang="scss">
.address-program {
  &__kpi {
    &-block {
      margin-top: 5px;
      background-color: var(--prospace-ui-input);
      padding: 8px;
      border-radius: 5px;
      font-size: 11px;
    }
    &-value {
      font-size: 12px;
      font-weight: 500;
      & > span {
        color: var(--prospace-text-gray);
      }
    }
    &-title {
      font-size: 11px;
      color: var(--prospace-text-gray);
    }
  }
  &__order-panel {
    .prospace-list-items .prospace-list-items-table {
      tr > td {
        vertical-align: middle;
        padding: 9px 20px 9px 0 !important;
        line-height: 11px !important;
        &:first-child {
          padding-left: 10px !important;
        }
      }
      tr > th {
        &:first-child {
          padding-left: 10px !important;
        }
      }
    }
    .prospace-tabs__header__tabs {
      padding: 0 10px;
    }
    .prospace-panel-header {
      &__title {
        .prospace-tag {
          text-transform: uppercase;
        }
      }
    }
    .prospace-panel-block {
      &__header {
        margin-bottom: 0;
      }
      &--empty {
        .prospace-panel-block-header {
          margin-bottom: 0;
        }
      }
    }
    & > .prospace-geo-layout {
      padding-bottom: 0;
    }
    &_adjustments {
      padding-bottom: 5px;
      height: 100%;
      .prospace-panel-block__body {
        padding-left: 0;
        padding-right: 0;
        height: calc(100% - 30px);
        .main-grid {
          min-width: 500px;
          height: 100%;
        }
      }
      .p-datatable-table {
        width: 100%;
      }
    }
    .prospace-geo-layout__bottom {
      .prospace-panel-block-list__row {
        &--4 {
          flex-flow: row wrap;
          align-items: flex-start;
          .prospace-panel-block-list__item {
            flex-basis: 115px;
            padding-bottom: 5px !important;
          }
        }
      }
    }
  }
  &__modal-exclude {
    &.prospace-modal.p-dialog.p-component {
      margin-top: 80px;
      max-width: 685px
    }
    .p-datatable .p-datatable-tbody > tr > td:first-child {
      padding-left: 0;
    }
    .prospace-list-items-table .p-datatable-tbody > tr:not(.p-datatable-row-expansion) > td {
      vertical-align: middle;
      &:last-child {
        padding: 5px 0;
      }
    }
  }
}
.kpi-stats {
  height: 32px;
}
</style>
